import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { formatDateAndTime } from "@/utils/dateFormat";
import { CalendarDays, Clock } from "lucide-react";

type Props = {
  item: Transaction;
};

const AttachmentCard: React.FC<Props> = ({ item }) => {
  return (
    <Dialog>
      <DialogTrigger className="relative min-w-[147px] h-[105px] rounded-xl overflow-hidden">
        <img
          className="w-full h-full object-cover opacity-30"
          src={item.File.full_url}
          alt="attachment"
        />
        <p className="absolute font-semibold top-2 left-2 text-sm text-primary underline">
          {item.type}
        </p>
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
      </DialogTrigger>

      <DialogContent className="min-w-[800px] min-h-[300px] overflow-y-scroll">
        <DialogHeader>
          <DialogTitle className="font-medium mb-4">
            Document attached
          </DialogTitle>
          <DialogDescription className="text-[#FF0000] text-right  font-semibold text-xs">
            please note that all files will be deleted automatically after 90
            days
          </DialogDescription>

          <div className="w-[80%] max-h-[600px] overflow-y-scroll p-4 space-y-2 rounded-xl shadow-xl ">
            <h2>{item.type} attached files</h2>

            <div className="flex gap-4 items-center">
              <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <CalendarDays className="h-4 w-4" />

                <span>
                  {formatDateAndTime(item.createdAt.toLocaleString()).date}
                </span>
              </div>
              <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <Clock className="h-4 w-4" />
                {formatDateAndTime(item.createdAt.toLocaleString()).time}
              </div>
            </div>
            <img
              className="w-full h-full object-cover "
              src={item.File.full_url}
              alt="attachment"
            />
          </div>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};

export default AttachmentCard;
